import styled from 'styled-components'

import {Container} from '~/components/general/container/Container'

export const AppointmentDetailsCard = styled.div`
  position: relative;
  padding: ${({theme}) => theme.spacing.lg};
  border-radius: ${({theme}) => theme.borderRadius.sm};
  box-shadow: ${({theme}) => theme.boxShadow.card};
  background-color: ${({theme}) => theme.colors.white};
  margin-top: ${({theme}) => theme.spacing.md};
`

export const CalendarGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: minmax(300px, 380px) 1fr;
  gap: 16px;
  align-items: stretch;
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`

export const CalendarColumn = styled(Container).attrs({
  direction: 'column',
  spacing: 2,
})`
  flex: 1 1 340px;
  min-width: 300px;
  height: 100%;
`

export const PatientDetailsContainer = styled.div`
display: flex;
flex-align: stretch;
width: 100%
display: inline-flex;
align-items: center;
margin-right: 0;
padding: 6px;
flex: 1;
justify-content: space-between;

&:hover {
    ${({onClick}) => !!onClick && 'cursor: pointer'};
  box-shadow: ${({onClick, theme}) => onClick && theme.boxShadow.card};
  }
`

export const AddAppointmentModalCard = styled.div`
  padding: ${({theme}) => theme.spacing.lg};
  border-radius: ${({theme}) => theme.borderRadius.sm};
  box-shadow: ${({theme}) => theme.boxShadow.card};
  background-color: ${({theme}) => theme.colors.white};
  margin-top: ${({theme}) => theme.spacing.md};
`
